import { render, staticRenderFns } from "./BlocksAndAlertsList.vue?vue&type=template&id=376aa302&scoped=true&"
import script from "./BlocksAndAlertsList.vue?vue&type=script&lang=js&"
export * from "./BlocksAndAlertsList.vue?vue&type=script&lang=js&"
import style0 from "./BlocksAndAlertsList.vue?vue&type=style&index=0&id=376aa302&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376aa302",
  null
  
)

export default component.exports